module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Cassete-29ba57c25b647a94dc0aa769fd2641a4.svg";